import React from 'react';
import { default as __ } from '../../../utils';
import Stat from './stat';
import Avatar from '../../../components/padel/avatar';
import Title from '../../../components/title';

function Rivals(props) {
  let { universe, rivals } = props;

  return (
    <section className="owl">
      <Title label={'rivals'} vertices={7} value={universe * 2} />

      <div stat-display="grid">
        <Stat value={rivals.top || 0} legend={'Top Level'}>
          <Avatar.Big shapeless variant="rivals" shade="var(--black)" />
        </Stat>

        <Stat value={rivals.same || 0} legend={'Same Level'}>
          <Avatar.Big shapeless variant="rivals" shade="var(--black)" />
        </Stat>

        <Stat value={rivals.low || 0} legend={'Low Level'}>
          <Avatar.Big shapeless variant="rivals" shade="var(--black)" />
        </Stat>
      </div>
    </section>
  );
}

export default Rivals;
